import React from "react";
import Button from "../../../components/Habitacional/core/Button/Button";

import { ReactComponent as Illustration } from "../../../assets/images/home/residential.svg";

import ContentSection from "../../../components/Habitacional/ContentSection";

import { links } from "../../../config";

const ResidentialSection = () => {
  return (
    <ContentSection
      title="Seguro Residencial"
      description="Acione seu seguro, consulte informações sobre a sua apólice, verifique dados financeiros e históricos de atendimento na área do cliente."
      illustration={<Illustration />}
      reverse
    >
      <div>
        <Button
          variant="primary"
          style={{ marginTop: "32px", marginBottom: "32px" }}
          onClick={() => window.open(links.areaLogada, "_blank")}
        >
          Acesse a área do cliente
        </Button>
        <p>
          Para consultar as condições gerais e manual de assistência, tirar
          dúvidas sobre o seu seguro ou conferir resultados dos sorteios,{" "}
          <a
            style={{ color: "#005FC8" }}
            href="/paravoce/residencial"
            target="_blank"
          >
            acesse aqui
          </a>
          .
        </p>
      </div>
    </ContentSection>
  );
};

export default ResidentialSection;
